import jwtDecode from "jwt-decode";

const getLocalStorageItem = () => {
  try {
    return localStorage.getItem("jobPortalUserInfo");
  } catch (error) {
    return error;
  }
};
const setLocalStorageItem = async (token) => {
  try {
    return localStorage.setItem("jobPortalUserInfo", token);
  } catch (error) {
    return error;
  }
};
const removeLocalStorageItem = async () => {
  try {
    return localStorage.removeItem("jobPortalUserInfo");
  } catch (error) {
    return error;
  }
};
const getUserFromLocalStorage = async () => {
  try {
    const token = await getLocalStorageItem("jobPortalUserInfo");
    if (token) return await jwtDecode(token);
  } catch (error) {
    return error;
  }
};

export {
  setLocalStorageItem,
  getLocalStorageItem,
  getUserFromLocalStorage,
  removeLocalStorageItem,
};
